import Vue from 'vue';
import Vuex from 'vuex';
import {AppMixins} from '@/components/commonMixin.js';
import wizard from './modules/wizard'
import carousel from './modules/carousel'

Vue.mixin(AppMixins);
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    wizard,
    carousel,
  },
  state: {

    userPalette: [
      [{"hex":"#c64b20", "location": 0}],
      [{"hex":"#18c619", "location": 0}],
      [{"hex":"#7590c6", "location": 0},{"hex":"#ffffff", "location": 1}],
      [{"hex":"#7590c6", "location": 0},{"hex":"#fff000", "location": 0.5},{"hex":"#ffffff", "location": 1}]
    ],

    logos: [
      {
        "layout" : 0,
        "icon": {'type': 'noun', 'id': 12345},
        "iconColor":[{"hex":"#7590c6"}],
        "title":"ECO\nQUARTZ\nLimited Corporation",
        "slogan":"SUPPORT FOR SMALL BUSINESS",
        "titleFamily":"Montserrat ExtraBold Alt1",
        "titleAlign": "left",
        "titleVariant":"800",
        "titleBoldness": 10,
        "titleX": 0,
        "titleY": 0,

        "sloganFamily":"Montserrat",
        "sloganVariant":"500",
        "titleScale":0.5,
        "sloganScale":0.7064264621355538,
        "sloganAlign": "center",
        "titleColor":[{"hex":"#7590c6", "location": 0},{"hex":"#ffffff", "location": 1}],
        "sloganColor":[{"hex":"#7590c6", "location": 0},{"hex":"#fff000", "location": 0.5},{"hex":"#ffffff", "location": 1}],
        "sloganBoldness": 0,
        "sloganX": 0,
        "sloganY": 0,
        "backgroundColor":[{"hex":"#2d303c"}],
        "titleLetterSpace":5,
        "titleLineSpace":1.1,
        "sloganLetterSpace":11,
        "sloganLineSpace":1.1,
        "iconScale":1,
        "iconSpace":1,
        "iconX": 0,
        "iconY": 0,
        "autoScale":true,
        "nthChar": 0,
        "container" : null,
        "containerColor":[{"hex":"#00ff00"}],
        "containerScale" : 1,
        "palette":["#2d303c","#7590c6","#7590c6","#7590c6","#7590c6"]
      },
      {
        "layout" : 1,
        "icon":{'type': 'custom', 'preview': 'img/test-icon.png'},
        "iconColor":[{"hex":"#7590c6"}],
        "title":"ECO QUARTZ",
        "slogan":"for small business",
        "titleFamily":"Montserrat ExtraBold Alt1",
        "titleAlign": "center",
        "titleVariant":"800",
        "titleBoldness": 0,
        "titleX": 0,
        "titleY": 0,

        "sloganFamily":"Montserrat",
        "sloganVariant":"500",
        "titleScale":0.5,
        "sloganScale":0.7064264621355538,
        "sloganAlign": "center",
        "titleColor":[{"hex":"#7590c6", "location": 0},{"hex":"#ffffff", "location": 1}],
        "sloganColor":[{"hex":"#7590c6", "location": 0},{"hex":"#fff000", "location": 0.5},{"hex":"#ffffff", "location": 1}],
        "sloganBoldness": 0,
        "sloganX": 0,
        "sloganY": 0,
        "backgroundColor":[{"hex":"#2d303c"}],
        "titleLetterSpace":5,
        "titleLineSpace":1.1,
        "sloganLetterSpace":11,
        "sloganLineSpace":1.1,
        "iconScale":1,
        "iconSpace":1,
        "iconX": 0,
        "iconY": 0,
        "autoScale":true,
        "nthChar": 0,
        "container" : {'type': 'custom', 'preview': 'img/test-container.png'},
        "containerColor":[{"hex":"#00ff00"}],
        "containerScale" : 1.5,
        "palette":["#2d303c","#7590c6","#7590c6","#7590c6","#7590c6"]
      }
    ],
  },
  mutations: {
    // Mutation for add new color/gradient to Palette
    addColorToPalette (state, newColor) {
      state.userPalette.push(newColor);
    },

    // Mutation for Update Color
    updateColor(state, data){
      state[data.type][data.index][data.element] = data.colorArray
    },

    // Mutation for Update Logo Data
    updateLogoData (state, data) {
      state.logos[data.index][data.element] = data.colorArray;
    },

    // remove color/gradient from  Palette by index
    removeColorPalette (state, index) {
      state.userPalette.splice(index, 1)
    },

  },
  getters: {
    getLogosData: state => {
      return state.logos;
    },

    getItemLogoData: state => index => {
      return state.logos[index];
    },

    getColorObject: state => data => {
      return state[data.type][data.index][data.element];
    },

    getListPalette: state => {
      return state.userPalette;
    },
    getListPaletteRender: state => {
      let renderArray = [];
      state.userPalette.forEach(function (item) {
        renderArray.push(AppMixins.methods.generateBackground(item));
      });
      return renderArray;
    }
  }
})
